import { useGtm } from '@gtm-support/vue2-gtm';
import { Dictionary } from '../../../../utils/src';

export function pushDataLayerGTM<T = Dictionary>(payload: T) {
  const gtm = useGtm();
  gtm?.trackEvent(payload);
}
